import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { b2bApi } from '../api/client';
import { useAuth } from './AuthContext';

const PricingContext = createContext({ isB2B: false, loading: true });

export function PricingProvider({ children }) {
  const { user } = useAuth();
  const [isB2B, setIsB2B] = useState(false);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    if (!user) { setIsB2B(false); setLoading(false); return; }
    try {
      const { data } = await b2bApi.status();
      setIsB2B(data.isApproved === true);
    } catch {
      setIsB2B(false);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { check(); }, [check]);

  return (
    <PricingContext.Provider value={{ isB2B, loading }}>
      {children}
    </PricingContext.Provider>
  );
}

export function usePricingContext() {
  return useContext(PricingContext);
}

export function exclVat(priceInclVat, vatRate = 0.06) {
  return priceInclVat / (1 + vatRate);
}
